module.exports = __webpack_public_path__ + "img/tucson-19.c322353d.png";